import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import MenuItem from '../components/MenuItem';
import '../App.css';
// import _ from 'lodash';
import Auth from '../core/services/auth';
import Avatar from 'react-avatar';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DataResponsetype } from '../core/lib/types';
import Back from '../components/backComponent';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { toast, ToastContainer } from 'react-toastify';
import PageLoader from '../components/PageLoader';
import VendorStoryComponent from '../components/VendorStoryComponent';
import _ from 'lodash';

function Vendor() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { name } = state || {};
    const [ type, setType ] = useState("")
    const [ openVendor, setOpenVendor] = useState(false)
    const inputLogoRef = useRef<HTMLInputElement>(null)
    const [ displayName, setDisplayName ] = useState('')
    const [ website, setWebsite ] = useState('')
    const [ email, setEmail ] = useState('')
    const [ description, setDescription ] = useState('')
    const [ logo, setLogo ] = useState<File | null>()
    const [ openUsername, setOpenUsername ] = useState(false)

    console.log(name)
    
    const vendor = Auth.getVendor().find((e: { name: any; })=>e.name === name)

    console.log(vendor)

    useEffect(()=>{
      if (!name && typeof(vendor) === "undefined") {
          navigate('/profile')
      }
    })

    const [ params, setParams ] = useState({
        page: 1, limit: 6, sort: "-createdAt", vendorId: vendor._id
    })
    

    const [ story, setStory ] = useState<DataResponsetype>({ total: 0, pages: 0, page: 0, limit: 0, data: [] })

    const getData = useCallback(() => {
      //
      // setType(args)
      if (type === "posts") {
        //
        // Auth.api.get("/posts", { params: params} ).then(res=>{
        //     setPost(res.data.data)
        // })

      } else if (type === "pins") {
          //
          // Auth.api.get("/pins", { params: params}).then(res=>{
          //     setPost(res.data.data)
          // })
      } else {
          Auth.api.get("/stories", { params: params} ).then(res=>{
            setStory(res.data.data)
          })
      }

    }, [params, type ])

    // use effect
    useEffect(() => {
      
      setType('')
      getData()
      
    }, [setType, getData, navigate])

    const onSet = (ars: string) => {
      //
      setParams({
          page: 1, limit: 6, sort: "-createdAt", vendorId: vendor._id
      })
      setType(ars)
    }

    const fetchData = () => {
      //
      if (story.data.length >= story.total) {
          // setMore(false)
          return;
      }

        params.page++

      //   console.log(params)

      Auth.api.get("/stories", { params: params} ).then(res=> {
        //
          setStory({
            total: story.total, 
            pages: story.pages, 
            page: story.page, 
            limit: story.limit,
            data: story.data.concat(res.data.data.data)
          })

          console.log(story.data)
            
          console.log(params)
        })
        .catch(err=>{
    
          console.log(err)

        })
    }

    const _stories = story.data.length > 0 ? story.data : []

    const storyItems = _stories.map(
        (story: any, index) => 
          <VendorStoryComponent 
            key={index}
            caption={story.caption} 
            media={story.media} 
            vendor={story.vendor} 
            createdAt={story.createdAt} 
            vendorId={story.vendorId}
            id={story.id} 
            />
          
      )
    

      function handleLogoClick (e: any) {
        // console.log(e)

        inputLogoRef.current?.click()
    }


    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setLogo(event.target.files[0])
        }
    }
    

    const [ loading, setLoading ] = useState(false)

    const handleSubmit = (event: any) => {
      
        event.preventDefault();

        setLoading(true)

        //  set form data
        const formData = {
            id: vendor._id,
            name: name ? name : vendor.name,
            website: website ? website : vendor.website,
            email: email ? email : vendor.email,
            description: description ? description : vendor.description,
            logo: logo,
            UserId: '',
            location: []
        }

        Auth.updateVendorAccount(formData).then(res=>{
          
            setLoading(false)
  
            console.log(res.data)
              
            toast.success(res.data.message, {
              position: "top-center",
            });

            //  setup vendor
            Auth.setVendor(res.data.data)
  
          }).catch(err=>{
    
            console.log(err)
    
            setLoading(false)

            // setTimeout(()=>{
            //   // navigate 
            //   navigate('/verify-password', { state: { email: email, otp: code } })
            // }, 1800)
            toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
               position: "top-center",
            });
            
    
        })

      }

      const handleUsernameSubmit = (event: any) => {
        //
        event.preventDefault()
  
        setLoading(true)
  
        Auth.api.post('/vendor-admins/', {  username: displayName, vendorId: vendor.id }).then(res=>{
  
          setLoading(false)
  
          //  update user profile
          // Auth.authUser().then(res => {
          //   //
          //   Auth.setUser(res.data.data)
          // })
  
          toast.success("Successfully added a Vendor Admin ", {
            position: "top-center",
          });
  
        }).catch(err=>{
  
          setLoading(false)
          
          console.log(err)
  
          if (typeof(err.response) !== "undefined") {
            if (err.response.data && _.isArray(err.response.data.error)) {
                let error = err.response.data.error
                //
                for (let index = 0; index < error.length; index++) {
                  const err = error[index];
                  toast.error(err.message, {
                    position: "top-center",
                  });
                }
              } else {
                toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                  position: "top-center",
                });
              }
        }
        })
      }

    return (
        <section className='dark:bg-gray-800 dark:text-white'>
          { loading ? <PageLoader /> : '' }
          <div className=' w-full py-5 mb-2'>
            <Back className='py-4 px-5 absolute start-0 flex' title='Profile'/>
            <div className='py-3 px-5 absolute end-0 flex'>
              <NavLink to="/event" state={{name: name}} className=""> 
                <button type="button" className="flex flex-row items-center justify-items-center py-1.5 px-5 bg-gray-100 mb-2 text-xs font-medium text-yellow focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:bg-black dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                  <span className='pr-0.5'>Events</span> 
                  <svg className="text-yellow w-3 h-3 pt-0.5" fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowForwardIosIcon"><path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"></path></svg>
                    
                </button>
                    
              </NavLink>
            </div>
          </div>
          <ToastContainer />
          <div className="flex flex-col px-6 py-8 mx-auto md:h-screen ">
            {vendor &&
              <div className="flex flex-row items-center space-y-1 relative">
                      {(vendor.logo) ?
                                        
                        <div style={{width:'65px', height: ''}} className="border bg-gray-100 border-slate-400 rounded-full">
                            <div className="bg-white block rounded-full  hover:-rotate-6 transform transition aspect-square flex align-center">
                              <img alt='profile' className='rounded-full object-cover p-0.5' src={vendor.logo.url}/>
                            </div>
                        </div>              
                      :
                        !(vendor.logo) &&
                        <Avatar round={true} size='65' name={vendor.name} />
                      }
                      {/* <div className='relative' style={{width:'105px', height: '5px'}}> */}
                      <NavLink to="/post" state={{ vendor: { name: vendor.name, id: vendor.id } }}>
                            <button className="absolute bottom-0 left-11 bg-slate-800 rounded h-6 w-6 
                            text-white font-semibold border-2
                            border-white dark:bg-black flex justify-center items-center font-mono hover:bg-blue-700">+</button>
                      </NavLink>
                        {/* </div> */}
                  <div className='ml-4 text-left'>
                      <h2 className='text-md font-bold mb-0 pb-0' onClick={e=>setOpenVendor(true)} >{vendor.name}</h2>
                      <p className='text-sm text-gray- mb-0 pb-0'>{vendor.description } <button onClick={e=> setOpenUsername(true)} type="button" className="py-1 px-3 text-white me-5 dark:bg-black bg-slate-800 text-xs font- focus:outline-none rounded-full border border-gray-200 hover:bg-gray-800 focus:bg-gray-700 focus:text-white
                        ">
                          manage</button></p>
                      <p onClick={e=>setOpenVendor(true)}  className='text-xs text-gray-500 mb-0 pb-0'>{vendor.website ? vendor.website : vendor.location ? vendor.location.name.split(',')[1]+', '+vendor.location.name.split(',')[2] : '' }</p>
                  </div>
              </div>
            }
            <div className="md:h-screen mx-auto space-y-2 mb-20 mt-10">
                  <InfiniteScroll
                          dataLength={story.data.length}
                          hasMore={true}
                          next={fetchData}
                          loader={<p className='text-center'></p>}
                      >
                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-1">
                          
                              {
                                  // _posts.map(
                                  //     (post: any, index) => 
                                  //       <ProfileStoryComponent 
                                  //         key={index}
                                  //         caption={post.caption} 
                                  //         media={post.media} 
                                  //         user={post.user} 
                                  //         location={post.location} 
                                  //         id={post.id} 
                                  //         vendor={post.vendor}
                                  //         createdAt={post.createdAt}
                                  //         meta={post.meta}
                                  //         user_action={post.user_action}
                                  //         profile={post.profile}
                                  //         />
                                      
                                  //   )
                                  storyItems
                              }
                          </div>
                  </InfiniteScroll>
                <button className='invisible' onClick={e=>onSet('')}></button>
                {/* file input */}
                <input ref={inputLogoRef} accept='image/*' type="file" name="logo" id="logo" className="invisible top-5 bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ handleFileChange } placeholder="Logo" required={true}/>
            </div>
            {/* Form Modal */}
            <Dialog open={openVendor} onClose={setOpenVendor} className="relative z-10">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />

              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                  >
                    
                    <form className="space-y-4 md:space-y-5 p-6" onSubmit={handleSubmit}>
                          <div className='pt-2 px-2  text-left'>
                            <p className='text-sm font-medium'> Vendor Details</p>
                          </div>
                          <div>
                              <input type="text" minLength={3} name="name" id="name" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setDisplayName(e.target.value) } placeholder="Name" value={displayName ? displayName : vendor.name} required={true}/>
                              
                          </div>
                          <div className='grid grid-cols-2 gap-4'>
                                  <div>
                                      <input type="text" name="website" id="website" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setWebsite(e.target.value) } placeholder="Website" value={website ? website : vendor.website} required={false}/>
                                  </div>
                                  <div>
                                      <div className="relative">
                                          <button type='button' onClick={handleLogoClick} className="absolute z-20 inset-y-0 end-0 flex items-center px-5">
                                              
                                              <svg className="w-7 h-7 text-dark dark:text-gray-400" focusable="false" aria-hidden="true" viewBox="0 0 24 24" ><circle cx="12" cy="12" r="3.2"></circle><path d="M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5"></path></svg>
                                          </button>
                                          <input type="text" id="logoText" disabled={true} className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 z-10 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={logo ? logo.name : 'Select Logo'}/>
                                      </div>

                                      {/* {logo && <p className='text-xs font-medium'>{logo.name}</p>} */}
                                  </div>
                          </div>
                          <div>
                              <input type="email" name="email" id="email" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setEmail(e.target.value) } placeholder="Email" value={email ?  email : vendor.email} required={true}/>
                          </div>
                          <div>
                              <input type="text" name="description" id="description" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setDescription(e.target.value) } placeholder="Description" value={description ? description : vendor.description} required={true}/>
                          </div>
                          <div className='flex flex-col space-y-4 '>
                              <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Update</button>
                              
                          </div>
                          
                      </form>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>

            <Dialog open={openUsername} onClose={setOpenUsername} className="relative z-20">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                >
                  <form onSubmit={handleUsernameSubmit} className="space-y-4 p-6 w-full">
                          <div className='pt-2 px-2  text-left'>
                            <p className='text-sm font-medium'>Add Username to Vendor</p>
                          </div>
                          <div className=''>
                            <input type="text" minLength={3} name="displayName" id="displayName" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setDisplayName(e.target.value) } placeholder="Username" value={displayName} required={true}/>
                            
                          </div>
                          {/* <div>
                            <input type="text" minLength={4} name="fullname" id="fullname" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setFullname(e.target.value) } placeholder="Firstname Lastname" value={fullname} required={true}/>
                          </div>
                          <div className='grid grid-cols-3 gap-4'>
                            <div>
                                <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                            </div>
                            <div className='col-span-2'>
                                <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                            </div>
                          </div> */}
                          <div className='flex flex-col space-y-4 '>
                            <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Submit</button>
                            
                          </div>
                    </form>
                  {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Deactivate
                    </button>
                    <button
                      type="button"
                      data-autofocus
                      onClick={() => setOpen(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div> */}
                </DialogPanel>
              </div>
            </div>
          </Dialog>
          </div>
        </section>
    );
  }
  
  export default Vendor;
  

